import { CompositeSessionFilter, FilterAttribute, FilterOperator, OperatorType } from '../../../../components/SessionFilters/model'

export const TEST_SESSION_FILTER: CompositeSessionFilter = {
  filters: [
    {
      filters: [
        { filter: { op: FilterOperator.IN, val: '{all}', attr: FilterAttribute.USER_ID }, type: 'individual' },
        {
          filters: [
            { filter: { op: FilterOperator.EQUALS, val: true, attr: FilterAttribute.ZOCKS_ANALYZED }, type: 'individual' },
            { filter: { op: FilterOperator.EQUALS, val: false, attr: FilterAttribute.PROCESSED }, type: 'individual' },
          ],
          operator: OperatorType.AND,
          type: 'composite',
        },
      ],
      operator: OperatorType.AND,
      type: 'composite',
    },
    { type: 'individual', filter: { op: FilterOperator.LT, attr: FilterAttribute.STARTED, val: '{now}' } },
  ],
  operator: OperatorType.AND,
  type: 'composite',
}
